import { OrderType, OrderTypes } from 'src/constants/OrderType';

export function isDeliveryOrder(orderType?: OrderType): boolean {
    return orderType === OrderTypes.DELIVERY_ORDER;
}
